/* unplugin-vue-components disabled */import { render } from "./SpeachDiagramTranslationDialog.vue?vue&type=template&id=42cc8c34&scoped=true&ts=true"
import script from "./SpeachDiagramTranslationDialog.vue?vue&type=script&lang=ts"
export * from "./SpeachDiagramTranslationDialog.vue?vue&type=script&lang=ts"

import "./SpeachDiagramTranslationDialog.vue?vue&type=style&index=0&id=42cc8c34&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42cc8c34"]])

export default __exports__